import { useState } from "react";
import { Autoplay, type Swiper as SwiperType } from "swiper";
import { SwiperSlide } from "swiper/react";
import { BodyStyle, SlideStyle, StyledCarousel, StyledTitleContainer } from "./Carousel.styles";
import { WidgetElement } from "./MinorComponents/CarouselWidget.component";
import { TitleTypography } from "./Typography";
import { useLanguageStore } from "../../stores";

type IProps = {
  carouselData: WidgetElement[],
  onSwipeSetIstance: (state: SwiperType) => void,
  handleRedirectUrl: () => string,
  isLinkRelative?: boolean
}

export const Carousel = ({ carouselData, onSwipeSetIstance, handleRedirectUrl, isLinkRelative }: IProps) => {
  const language = useLanguageStore(state => state.language)?.id;
  const [activeSlide, setActiveSlide] = useState<number | null>(null);
  const onSetActiveSlide = (state: SwiperType) => {
    setActiveSlide(state.activeIndex);
    onSwipeSetIstance(state);
  };
  const isActiveSlide = (index: number) => activeSlide === index;

  return (
    <BodyStyle>
      <StyledCarousel
        autoplay={ {
          delay: 7000,
          disableOnInteraction: true

        } }
        modules={ [Autoplay] }
        onSwiper={ onSetActiveSlide }
        onActiveIndexChange={ onSetActiveSlide }
      >
        { carouselData?.map((card: WidgetElement, i) => (
          <SwiperSlide
            key={ `carousel-slide-${i}--${language}` }
            aria-hidden={ isActiveSlide(i) ? false : true }
            tabIndex={ isActiveSlide(i) ? 0 : -1 }
          >
            <StyledTitleContainer
              aria-label={ "carousel-" + card.title }
            >
              <TitleTypography id={ "carousel-" + card.title }>
                { card.title }
              </TitleTypography>
            </StyledTitleContainer>
            <a
              href={ handleRedirectUrl() }
              target={ isLinkRelative ? "_self" : "_blank" }
              rel={ isLinkRelative ? undefined : "noopener noreferrer" }
              onClick={ (e) => {
                e.stopPropagation();
              } }
            >
              <SlideStyle imageUrl={ card.coverPublicURL } />
            </a>
          </SwiperSlide>
        )) }

      </StyledCarousel>
    </BodyStyle>
  );
};
